/* eslint-disable no-unused-vars */
import { FC } from "react";
import { useField } from "formik";
import { FormItem, Input } from "formik-antd";
import { Styles } from "../styled";
import { useConfirmingLeave } from "@lhd/app/index";

type IProps = {
  name: string;
  label?: string;
  type?: string;
  inputMode?:
    | "text"
    | "search"
    | "none"
    | "tel"
    | "url"
    | "email"
    | "numeric"
    | "decimal";
  className?: string;
  required?: boolean;
  placeholder?: string;
  disabled?: boolean;
  suffix?: any;
  onChange?: (e: any) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement, Element>) => void;
  onKeyDown?: (e: any) => void;
  convertDataOnBlur?: (e: any) => void;
  onClick?: (e: any) => void;
  setFieldValue?: (field: string, value: any) => void;
  isLeaveForm?: boolean;
  defaultValue?: string | number | readonly string[];
  hasRequiredBg?: boolean;
  boldLabel?: boolean;
};

const InputField: FC<IProps> = ({
  name,
  label,
  required = false,
  className,
  placeholder = "",
  type = "string",
  inputMode = "text",
  disabled = false,
  setFieldValue,
  onChange,
  suffix,
  onClick,
  isLeaveForm = false,
  onKeyDown = undefined,
  convertDataOnBlur = undefined,
  onBlur,
  defaultValue,
  hasRequiredBg = false,
  boldLabel = false,
}) => {
  const { checkLeaveForm } = useConfirmingLeave();
  const [field] = useField(name);

  const isRequiredEmpty =
    required &&
    hasRequiredBg &&
    (field.value === undefined || field.value === null || field.value === "");

  return (
    <Styles isLabelBold={boldLabel}>
      <FormItem
        name={name}
        label={label}
        className={`${className ?? ""} ${
          isRequiredEmpty ? "required-field" : ""
        }`}
        required={required}
      >
        <Input
          // autoFocus
          suffix={suffix}
          inputMode={inputMode}
          placeholder={placeholder}
          name={name}
          type={type}
          onBlur={(e) => {
            setFieldValue &&
              setFieldValue(
                name,
                convertDataOnBlur
                  ? convertDataOnBlur(e.target.value.trim())
                  : e.target.value.trim(),
              );
            onBlur && onBlur(e);
          }}
          {...(onKeyDown ? { onKeyDown } : {})}
          disabled={disabled}
          onChange={(e: any) => {
            onChange && onChange(e);
            isLeaveForm && checkLeaveForm();
          }}
          onClick={onClick}
          autoComplete="off"
          defaultValue={defaultValue}
        />
      </FormItem>
    </Styles>
  );
};

export default InputField;
